import React from 'react'
import { observer } from 'mobx-react-lite'

import Stack from '@mui/material/Stack'

import { useAccountStore, useGlobalCopyStore } from '../../../common'
import { AccountType } from '../../../core'

import TotalCard from '../shared/TotalCard'
import Accounts from '../shared/Accounts'

const AvailableTabContent: React.FC = () => {
  const { savingsAndCheckingAccountsBalance } = useAccountStore()
  const { finstrong: copy } = useGlobalCopyStore()

  return (
    <Stack gap={16} sx={{ p: 16 }}>
      <TotalCard
        balance={savingsAndCheckingAccountsBalance}
        title={copy.key_indicators_save.drawer_available_balance}
      />
      <Accounts
        loadAccounts={[AccountType.SAVINGS, AccountType.CHECKING]}
        loadMoreLabel={copy.more_accounts}
      />
    </Stack>
  )
}

export default observer(AvailableTabContent)
